import { combineReducers } from 'redux'
import eventsData from './events'
import eventScheduleData from './eventSchedule'
import filtersData from './filters'

const rootReducer = combineReducers({
  eventScheduleData,
  eventsData,
  filtersData,
})

export default rootReducer
